import React, { FC } from 'react';
import { PresetStatusColorType } from 'antd/es/_util/colors';

import { useLang } from 'hooks';
import { Tag } from 'components/ui';
import { Override } from 'types/common';
import { TagProps } from 'types/components';
import { WithdrawalStatus as EWithdrawalStatus } from 'types/models';

const statusColors: Record<EWithdrawalStatus, PresetStatusColorType> = {
  [EWithdrawalStatus.CREATED]: 'processing',
  [EWithdrawalStatus.ERROR]: 'error',
  [EWithdrawalStatus.FAILED]: 'error',
  [EWithdrawalStatus.PENDING]: 'processing',
  [EWithdrawalStatus.SUCCESS]: 'success',
};

type WithdrawalStatusProps = Override<Omit<TagProps, 'color' | 'children'>, {
  status: EWithdrawalStatus;
}>;

const WithdrawalStatus: FC<WithdrawalStatusProps> = ({ status, ...props }) => {
  const lang = useLang();

  return (
    <Tag color={statusColors[status]} {...props}>
      {lang.get(`withdrawal.statuses.${status.toLowerCase()}`)}
    </Tag>
  );
};

export default WithdrawalStatus;
